import { preloadSourcingTenderEntryCounts } from "@/pages/admin-sourcing-entries/api/fetch-sourcing-tender-entry-counts-query";
import { preloadSourcingTenderEntries } from "@/pages/admin-sourcing-entries/api/fetch-sourcing-tender-entries-query";
import type { SourcingEntriesSearch } from "@/pages/admin-sourcing-entries/model/search-params";

export const preloadSourcingEntriesQueries = (
  search: SourcingEntriesSearch,
) => {
  preloadSourcingTenderEntries(search);
  preloadSourcingTenderEntryCounts();
};
